import Media from 'ember-responsive/services/media';
export default Media;
